import { render } from "./humVideoPlayer.vue?vue&type=template&id=37e1818c&scoped=true"
import script from "./humVideoPlayer.vue?vue&type=script&lang=js"
export * from "./humVideoPlayer.vue?vue&type=script&lang=js"

import "./humVideoPlayer.vue?vue&type=style&index=0&id=37e1818c&scoped=true&lang=css"

import exportComponent from "E:\\JzHyLyEdu\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37e1818c"]])

export default __exports__